export const homeStyles = {};
